import { atom, type PrimitiveAtom } from "jotai";

export const remoteClientDisconnectingVehicleSessionAtom: PrimitiveAtom<boolean> =
  atom(false);
